import Vue from "vue";
import Router from "vue-router";
import authenticate from "./middlewares/authenticate";
import guest from "./middlewares/guest";
import middlewarePipeline from "./middlewarePipeline";
import store from '../store/store.js';
import manager from "./middlewares/manager";
import checkManagerAccess from './middlewares/checkManagerAccess';
import hasPermission from './middlewares/hasPermission';

Vue.use(Router);
//-----------Prevent SSR Duplicate Routing issue----------------
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

//---------------------------------------------------------------

export function createRouter() {
  const router = new Router({

    mode: "history",
    routes: [
      {
        path: "/signup",
        name: "signup",
        component: () => import("@/components/SignUp/Signuphome"),
        meta: {
          middleware: [guest],
          layout: 'loginLayout'
        },
      },
      {
        path: "/login",
        alias: "/",
        name: "login",
        component: () => import("@/components/Login/login"),
        meta: {
          middleware: [guest],
          layout: 'loginLayout',
        },
      },
      {
        path: "/supportLogin",
        name: "supportLogin",
        component: () => import("@/components/Login/supportLogin"),
        meta: {
          middleware: [guest],
          layout: 'loginLayout',
        },
      },
      {
        path: "/forgot-password",
        name: "/forgot-password",
        component: () => import("@/components/Login/forgotpassword"),
        meta: {
          middleware: [guest],
          layout: 'loginLayout'
        },
      },
      {
        path: "/verifyCode",
        name: "verifyCode",
        component: () => import("@/components/Login/verifyCode"),
        meta: {
          middleware: [guest],
          layout: 'loginLayout',
        },
      },
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/components/Dashboard/home"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],

          permission: 'view_dashboard'
        }

      },
      // employee routes
      {
        path: "/employees",
        name: "employees",
        component: () => import("@/components/Employees/listEmployees"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],

          permission: 'view_employees',
        }
      },
      {
        path: "/employees/import",
        name: "employees-import",
        component: () => import("@/components/Employees/import"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],

          permission: 'import_employees'
        }
      },
      {
        path: "/employee/profile/:id",
        name: "employeeProfile",
        component: () => import("@/components/Employees/employeeProfile"),
        // component: require('@/components/Employees/employeeProfile.vue').default,
        meta: {
          middleware: [authenticate, hasPermission],
          permission: 'view_employee_profile'
        }
      },
      {
        path: "/employee/detail/:id",
        name: "employee/detail",
        component: () => import("@/components/Employees/employeeDetail"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'view_employee_detail'
        }
      },
      {
        path: "/employee/chart-of-account/:id",
        name: "employee/chart-of-account",
        component: () => import("@/components/Employees/employeeChartAccount"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'chart_of_account'
        }
      },
      {
        path: "/employee/documents/:id",
        name: "employee/documents",
        component: () => import("@/components/Employees/employeeDocuments"),
        meta: {
          middleware: [authenticate, hasPermission],
          permission: 'manage_employee_documents'
        }
      },
      {
        path: "/employee/benefits/:id",
        name: "employee/benefits",
        component: () => import("@/components/Employees/employeeBenefits"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'view_employee_detail'
        }
      },
      {
        path: "/employee/location/:id",
        name: "employee/location",
        component: () => import("@/components/Employees/employeeLocation"),
        // component: require('@/components/Employees/employeeProfile.vue').default,
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'manage_employee_benefits'
        }

      },
      {
        path: "/employee/locationLog/:id",
        name: "employee/locationLog",
        component: () => import("@/components/Employees/employeeLocation"),
        // component: require('@/components/Employees/employeeProfile.vue').default,
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'manage_employee_location'
        }

      },
      {
        path: "/employee/user-profile/:id",
        name: "profile",
        component: () => import("@/components/Employees/userProfile"),
        meta: {
          middleware: [authenticate, hasPermission],
          permission: 'view_employee_detail',
        },
      },
      {
        path: "/employee/hours/:id",
        name: "employees/hours",
        component: () => import("@/components/Employees/employeeHours"),
        meta: {
          middleware: [authenticate, hasPermission],
          permission: 'manage_employee_hours',
        },
      },
      {
        path: "/employee/salary/:id",
        name: "employees/salary",
        component: () => import("@/components/Employees/employeeSalary"),
        meta: {
          middleware: [authenticate, hasPermission],
          permission: 'manage_employee_salary',
        },
      },

      {
        path: "/employee/balance/:id",
        name: "employees/balance",
        component: () => import("@/components/Employees/employeeBalance"),
        meta: {
          middleware: [authenticate, hasPermission],
          permission: 'manage_employee_balance',
        },
      },

      {
        path: "/employee/shift/:id",
        name: "employees/shift",
        component: () => import("@/components/Employees/employeeShifts"),
        meta: {
          middleware: [authenticate, hasPermission],
          permission: 'manage_employee_shift',
        },
      },
      {
        path: "/employee/absence/:id",
        name: "employees/absence",
        component: () => import("@/components/Employees/employeeAbsence"),
        meta: {
          middleware: [authenticate, hasPermission],
          permission: 'view_employee_absence',
        },
      },

      {
        path: '/employee/permissions/:id',
        name: 'employee-permissions',
        component: () => import('@/components/Employees/PermissionManager'),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'permission_manager'
        }
      },
      {
        path: "/employee/report-to/:id",
        name: "report-to",
        component: () => import("@/components/Employees/SupervisorSubordinate"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'report_to',
        },
      },


      {
        path: "/attendance/punchin",
        name: 'attendance/punchin',
        component: () => import("@/components/attendance/punchin"),
        meta: {
          middleware: [authenticate, hasPermission],
          permission: 'punch_in',
        },
      },
      {
        path: "/Dashboard/employeehome",
        name: 'Dashboard/employeehome',
        component: () => import("@/components/Dashboard/employeehome"),
        meta: {
          middleware: [authenticate, hasPermission],
          permission: 'employee_home',
        },
      },

      // employee routes end
      {
        path: "/leaves",
        name: "leaves",
        component: () => import("@/components/Employees/employeeLeaves"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'view_leaves'
        }

      },
      {
        path: "/salary-calculator",
        name: "salary-calculator",
        component: () => import("@/components/Hours_Salary/salary-calculator"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'view_salary_calculator'
        }
      },
      {
        path: "/salary-calculator/:id",
        name: "salary-calculator-edit",
        component: () => import("@/components/Hours_Salary/salary-calculator-edit"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'edit_salary_calculator'
        }
      },
      {
        path: "/salary-list",
        name: "employee-salariesList",
        component: () => import("@/components/Hours_Salary/salaryList"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'view_salary_list'
        }
      },

      //    {
      //      path: "/about-us",
      //      name: "aboutUs",
      //      component: () => import("@/components/static/AboutUs"),
      //    },

      {
        path: "/schedule-overlayer",
        name: "schedule-overlayer",
        component: () => import("@/components/Schedule/schedule-overlayer"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'view_schedule'
        }
      },
      {
        path: "/schedule",
        name: "schedule",
        // component: () => import("@/components/Schedule/create"),
        component: () => import("@/components/Schedule/index"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'view_schedule'
        }
      },
      {
        path: "/schedule/:id",
        name: "scheduleId",
        component: () => import("@/components/Schedule/index"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'edit_schedule'
        }
      },
      {
        path: "/schedule/publish/:id/weeks",
        name: "publish-schedule",
        component: () => import("@/components/Schedule/index_publish"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'publish_schedule'
        }
      },
      {
        path: "/schedule/publish/:id/weeks/:week/date/:date",
        name: "publish-schedule-detail",
        component: () => import("@/components/Schedule/index_publish_detail"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'publish_schedule'
        }
      },
      {
        path: "/template",
        name: "template",
        component: () => import("@/components/Schedule/template-view"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'view_schedule_template'
        }
      },
      {
        path: "/tax-slabs",
        name: "tax-slabs",
        component: () => import("@/components/TaxSlab/index"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'manage_tax_slabs'
        }
      },
      {
        path: "/upgrade-plan",
        name: "upgrade-plan",
        component: () => import("@/components/Membership/index"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'upgrade_plan'
        }
      },
      {
        path: "/payment",
        name: "payment",
        component: () => import("@/components/Membership/payment"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'make_payment'
        }
      },
      {
        path: "/success",
        name: "success",
        component: () => import("@/components/Membership/success"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'make_payment'
        }
      },
      {
        path: "/checkout",
        name: "checkout",
        component: () => import("@/components/Membership/checkout"),
        meta: {
          middleware: [authenticate, hasPermission],
          permission: 'checkout',
        },
      },
      {
        path: "/new-company",
        name: "new-company",
        component: () => import("@/components/company/newcomp"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'create_company'
        }
      },
      {
        path: "/company-profile",
        name: "company-profile",
        component: () => import("@/components/company/companyProfile"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'view_company_profile'
        }
      },
      {
        path: "/requests",
        name: "requests",
        component: () => import("@/components/Settings/request"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'manage_requests'
        }
      },
      {
        path: "/messages/inbox",
        name: "messages-inbox",
        component: () => import("@/components/Message/messages"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'view_messages'
        }

      },
      {
        path: "/messages/create",
        name: "messages-create",
        component: () => import("@/components/Message/create"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'create_messages'
        }
      },
      {
        path: "/map",
        name: "map",
        component: () => import("@/components/Employees/map"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'view_employee_map'
        }
      },
      {
        path: "/settings/general",
        name: "general",
        component: () => import("@/components/Settings/Setting/general"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'general_settings'
        }
      },
      {
        path: "/settings/position",
        name: "position",
        component: () => import("@/components/Settings/Setting/position"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'position_settings'
        }
      },
      {
        path: "/settings/location",
        name: "location",
        component: () => import("@/components/Settings/Setting/location"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'location_settings'
        }
      },
      {
        path: "/settings/administrators",
        name: "administrators",
        component: () => import("@/components/Settings/Setting/administrators"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'administrator_settings'
        }
      },
      {
        path: "/settings/work-shift",
        name: "work-shift",
        component: () => import("@/components/Settings/Setting/work-shift"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'work_shift_settings'
        }
      },
      {
        path: "/settings/assign-shift",
        name: "assign-shift",
        component: () => import("@/components/Settings/Setting/assign-shift"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'assign_shift_settings'
        }
      },
      {
        path: "/settings/change-password",
        name: "change-password",
        component: () => import("@/components/Settings/Setting/change-password"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'change_password'
        }
      },
      {
        path: "/settings/leaves",
        name: "settingsLeaves",
        component: () => import("@/components/Settings/Setting/leaves-setting"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'leave_settings'
        }
      },
      {
        path: "/settings/holidays",
        name: "holidays",
        component: () => import("@/components/Settings/Setting/holidays"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'holiday_settings'
        }
      },
      /* {
           path: "/settings/teams",
           name: "teams",
           component: () => import("@/components/Settings/Setting/Teams/index")
       },
       {
           path: "/settings/teams/add",
           name: "team-add",
           component: () => import("@/components/Settings/Setting/Teams/add")
       },*/
      {
        path: "/reports/attendance",
        name: "reports-attendance",
        component: () => import("@/components/Reports/attendanceReport"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'view_attendance_report'
        }
      },
      {
        path: "/reports/attendance-progress",
        name: "reports-attendance-progress",
        component: () => import("@/components/Reports/attendanceprogress"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'view_attendance_progress'
        }
      },
      {
        path: "/reports/attendance-maps",
        name: "reports-attendance-maps",
        component: () => import("@/components/Reports/attendanceMaps"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'view_attendance_map'
        }
      },

      {
        path: "/timesheet/customers",
        name: "timesheet-customers",
        component: () => import("@/components/TimeSheet/customer"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'manage_customers'
        }
      },
      {
        path: "/timesheet/projects",
        name: "timesheetProjects",
        component: () => import("@/components/TimeSheet/projects"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'manage_projects'
        }
      },
      {
        path: "/timesheet/project/:id?",
        name: "projectDetail",
        component: () => import("@/components/TimeSheet/project"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'view_project_detail'
        }
      },
      {
        path: "/timesheet/activities",
        name: "timesheet-activities",
        component: () => import("@/components/TimeSheet/activities"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'manage_activities'
        }
      },
      {
        path: "/timesheets",
        name: "timesheets",
        component: () => import("@/components/TimeSheet/timeSheet"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'view_timesheets'
        }
      },

      {
        path: "/timesheet/edit",
        name: "editTimeSheet",
        component: () => import("@/components/TimeSheet/timeSheetEdit"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'edit_timesheet'
        }
      },
      {
        path: "/timesheet/add/:id?",
        name: "editTimeSheetAdd",
        component: () => import("@/components/TimeSheet/timeSheetAdd"),
        meta: {
          middleware: [authenticate, hasPermission],
          permission: 'add_timesheet'
        }
      },
      {
        path: "/timesheet/edit/:id?/:tid?",
        name: "editTimeSheetId",
        component: () => import("@/components/TimeSheet/timeSheetEdit"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'edit_timesheet'
        }
      },
      {
        path: "/timesheet/view/:id?/:tid?",
        name: "timeSheetView",
        component: () => import("@/components/TimeSheet/timeSheetView"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'view_timesheet'
        }
      },
      {
        path: "/partner/product-items",
        name: "partnerProductItems",
        component: () => import("@/components/PartnerOffers/index"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'view_partner_products'
        }
      },
      {
        path: "/partner/transactions",
        name: "partnerTransactions",
        component: () => import("@/components/PartnerOffers/transactions"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'view_partner_transactions'
        }
      },

      {
        path: "/company/:id/edit-company",
        name: "edit-company",
        component: () => import("@/components/company/edit-company"),
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'edit_company'
        }
      },
      {
        path: "/:id",
        name: "my-companies",
        component: () => import("@/components/company/get-company"),
        /*meta: {
          middleware: [authenticate,hasPermission],
          permission: 'view_employee_detail',
          layout: 'loginLayout',
        },*/
        meta: {
          middleware: [authenticate, checkManagerAccess, hasPermission],
          permission: 'my_companies'
        }
      },
      {
        path: "*",
        name: "pageNotFound",
        component: () => import("@/components/static/PageNotFound"),
      }
    ]
  });

  //var isTranslationLoaded = false;
  router.beforeEach((to, from, next) => {
    const store = router.app.$store;
    //console.log('store==',router.app.$store.getters.getSelectedCompany.status);
    setLayout(to, from, next);
    //=================Middleware Handling=========================
    if (!to.meta.middleware) {
      return next();
    }
    const middleware = to.meta.middleware;
    const context = {
      to,
      from,
      next,
      store: router.app.$store
    };
    return middleware[0]({
      ...context,
      next: middlewarePipeline(context, middleware, 1)
    });
    //=================Middleware Handling End=========================
    //    if (current_lang != "en_US" && !isTranslationLoaded) {
    //        import(`@/lang/${current_lang}`).then(function (locale) {
    //            isTranslationLoaded = true;
    //            i18n.setLocaleMessage(current_lang, locale.messages);
    //            i18n.locale = current_lang;
    //        });
    //    }
  });

  function setLayout(to, from, next) {
    router.app.$store.commit("SET_LAYOUT", to.meta.layout || 'defaultLayout');
  }

  return router;
}
